module.exports = __webpack_public_path__ + "e6d2dd0c48fbd404ff4a0102d4aa0bdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/x_corp_2023_chart.png
// module id = 1762
// module chunks = 0